import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { demoDomainHref, getDemoDomain, type DemoDomain } from '../../data/demoCenter';
import { fadeUp } from '../../utils/motion';
import { DomainIcon } from './DomainIcon';
import { DemoStatusBadge } from './DemoStatusBadge';

/** Solution-page band linking to a domain's card and detail in the Demo Center. */
export function DemoCenterLink({
  domainId
}: {
  domainId: DemoDomain['id'];
}) {
  const domain = getDemoDomain(domainId);
  if (!domain) return null;
  return <section aria-label={`${domain.solutionLabel} in the Noetivra Demo Center`} className="bg-white border-b border-line py-12" data-id="element-216" data-mp="1tal8dmyd8gf">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row md:items-center gap-6 md:gap-10" data-id="element-217" data-mp="bkx5ezh9qhvb">
        <div className="flex items-start gap-4 flex-1" data-id="element-218" data-mp="folclh1znbg1">
          <DomainIcon id={domain.id} data-id="element-219" data-mp="kl3g6dll13qs" />
          <div data-id="element-220" data-mp="km4owbf4le5c">
            <div className="flex flex-wrap items-center gap-3" data-id="element-221" data-mp="kjiiwg7vv6p8">
              <p className="font-heading font-bold text-lg text-ink-dark" data-id="element-222" data-mp="28h9497bu1o9g">{domain.solutionLabel}</p>
              <DemoStatusBadge status={domain.status} data-id="element-223" data-mp="24e2uhppihey8" />
            </div>
            <p className="mt-1 text-ink-muted leading-relaxed max-w-2xl" data-id="element-224" data-mp="1zezske4tvouh">{domain.description}</p>
          </div>
        </div>
        <a href={demoDomainHref(domain.id)} className="inline-flex items-center justify-center gap-2 rounded-md border border-line px-5 py-3 font-semibold text-navy hover:bg-surface-muted hover:border-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-225" data-mp="1uhztwoab5ode">
          Explore the planned Noetivra workflow
          <ArrowRight size={16} aria-hidden="true" data-id="element-226" data-mp="2dfkbdaaqtknz" />
        </a>
      </motion.div>
    </section>;
}